import React from 'react';
import { Chip, MenuItem, Stack, TextField } from '@mui/material';
import { GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import { FDataGrid } from '../grid';
import { ISimulationIssueRow } from './simulation.models';

type Props = {
  rows: ISimulationIssueRow[];
  rowCount: number;
  paginationModel: GridPaginationModel;
  severity: string;
  loading?: boolean;
  onSeverityChange: (severity: string) => void;
  onPaginationModelChange: (model: GridPaginationModel) => void;
  onRefresh: () => void | Promise<void>;
};

class SimulationIssuesGrid extends React.PureComponent<Props> {
  columns: GridColDef[] = [
    { field: 'severity', headerName: 'Severity', width: 120, renderCell: (p) => <Chip size="small" label={p.value || '-'} color={p.value === 'BLOCKING' ? 'error' : p.value === 'WARNING' ? 'warning' : 'info'} /> },
    { field: 'issuecode', headerName: 'Code', width: 165 },
    { field: 'issuename', headerName: 'Issue', minWidth: 230, flex: 1 },
    { field: 'entitycode', headerName: 'Entity', width: 145 },
    { field: 'periodcode', headerName: 'Period', width: 125 },
    { field: 'actualvalue', headerName: 'Actual', width: 120, type: 'number' },
    { field: 'expectedvalue', headerName: 'Expected', width: 120, type: 'number' },
    { field: 'description', headerName: 'Description', minWidth: 260, flex: 1 },
    { field: 'resolution', headerName: 'Resolution', minWidth: 240, flex: 1 },
  ];

  render() {
    return <Stack spacing={1.5}>
      <TextField select label="Severity" size="small" value={this.props.severity} onChange={(e) => this.props.onSeverityChange(e.target.value)} sx={{ width: 220 }}>
        <MenuItem value="">All severities</MenuItem><MenuItem value="BLOCKING">Blocking</MenuItem><MenuItem value="WARNING">Warning</MenuItem><MenuItem value="INFO">Information</MenuItem>
      </TextField>
      <FDataGrid title="Computation Issues" subtitle="Formula, constraint, capacity and data-quality exceptions from the latest computation." rows={this.props.rows} columns={this.columns} loading={this.props.loading} height={500} showQuickFilter refresh={this.props.onRefresh}
        paginationMode="server" rowCount={this.props.rowCount} paginationModel={this.props.paginationModel} onPaginationModelChange={this.props.onPaginationModelChange} pageSizeOptions={[25, 50, 100]} getRowId={(r) => r.id || r.rid || r.rix} />
    </Stack>;
  }
}
export default SimulationIssuesGrid;
